import {CategoryKeyEnum} from '#apollo/schema';
import {IconName} from '#component/base/Icon';

const categoryIconMap: Record<CategoryKeyEnum, IconName> = {
  [CategoryKeyEnum.Diet]: 'ForkKnife',
  [CategoryKeyEnum.Fitness]: 'Barbell',
  [CategoryKeyEnum.Habits]: 'Martini',
  [CategoryKeyEnum.Mental]: 'Smiley',
  [CategoryKeyEnum.Sleep]: 'Moon',
  [CategoryKeyEnum.You]: 'User',
  [CategoryKeyEnum.Research]: 'LightbulbFilament',
};

export const getCategoryIconName = (category: CategoryKeyEnum) => categoryIconMap[category];
